import axios from 'axios'

export type StatusApiResponse = {
  'overall-status': string
  details: Record<string, StatusDetail>
}

export type StatusDetail = {
  label?: string
  status: string
  critical: boolean
  errors?: string[]
}

export const AppStatusService = {
  async getStatus(): Promise<{ data: StatusApiResponse }> {
    return axios.get('/status')
  },
}
